<template>
    <div class="table_component">
        <table class="table">
            <thead>
                <tr>
                    <th style="text-align: center;" width="46">#</th>
                    <th v-for="item in col" :key="item.name">{{ item.name }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(node, index) in row.data" :key="'row'+index">
                    <td v-if="index == 0" :rowspan="row.data.length + 1" style="vertical-align: bottom; text-align: center;" >合计:</td>
                    <td v-for="(item, field) in col" :key="'col_'+index+'_'+field">{{ node[item.field] }}</td>
                </tr>
                <tr>
                    <td v-for="(item, field) in col" :key="'col_collsape_'+field" :colspan="item.rowspan" v-show="item.rowspan != 0">{{ row.total[item.field] }}</td>
                </tr>
                <tr>
                    <td :colspan="col.length + 1">备注： <span v-if="row.remark">{{ row.remark }}</span></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<style scoped lang="scss">
    .table_component{
        .table{
            th{ background: #EBEDF3; color: #000; font-weight: bold; line-height:20px; padding: 8px 5px; border-bottom: 1px solid #CCCCCC; border-right: 1px solid #CCCCCC; padding: 8px 5px; }
            td{ border-bottom: 1px solid #CCCCCC; border-right: 1px solid #CCCCCC; padding: 8px 5px; }
            border-collapse: collapse; width: 100%; border:1px solid #CCCCCC; border-bottom: 0px none; border-right: 0px none; font-size: 14px;
        }
        .red_remark{ font-size:16px; font-weight:bold; line-height:22px; color: #FF0000;  }
    }
</style>
<script>
    // import pagination from '../../components/pagination.vue'
    export default {
        props:{
            col : {
                type: [Array, Object],
                default: function(){
                    return [
                        { field: "field1",  name : "仓库", rowspan: 6, },
                        { field: "field2",  name : "库位号", rowspan: 0, },
                        { field: "field3",  name : "捆包号", rowspan: 0, },
                        { field: "field4",  name : "品名", rowspan: 0, },
                        { field: "field5",  name : "等级", rowspan: 0, },
                        { field: "field6",  name : "码单厚度", rowspan: 0, },
                        { field: "field7",  name : "厚度", rowspan: 2, },
                        { field: "field8",  name : "码单长度", rowspan:0 , },
                        { field: "field9",  name : "长度", rowspan: 1, },
                        { field: "field10", name : "码单总宽度", rowspan: 2, },
                        { field: "field12", name : "总宽度", rowspan: 0, },
                        { field: "field13", name : "总立方", rowspan: 1,}
                    ];
                }
            },
            row : {
                type: [Array, Object],
                default: function(){
                    return {
                        data : [
                            {  field1 : "field1", field2 : "field2", field3 : "field3", field4 : "field4", field5 : "field5", field6 : "field6", field7 : "field7", field8 : "field8", field9 : "field9", field10 : "field10", field12 : "field12", field13 : "field13" },
                            {  field1 : "field1", field2 : "field2", field3 : "field3", field4 : "field4", field5 : "field5", field6 : "field6", field7 : "field7", field8 : "field8", field9 : "field9", field10 : "field10", field12 : "field12", field13 : "field13" },
                            {  field1 : "field1", field2 : "field2", field3 : "field3", field4 : "field4", field5 : "field5", field6 : "field6", field7 : "field7", field8 : "field8", field9 : "field9", field10 : "field10", field12 : "field12", field13 : "field13" },
                            {  field1 : "field1", field2 : "field2", field3 : "field3", field4 : "field4", field5 : "field5", field6 : "field6", field7 : "field7", field8 : "field8", field9 : "field9", field10 : "field10", field12 : "field12", field13 : "field13" },
                        ],
                        total : { field1 : "field1", field2 : "field2", field3 : "field3", field4 : "field4", field5 : "field5", field6 : "field6", field7 : "field7", field8 : "field8", field9 : "field9", field10 : "field10", field12 : "field12", field13 : "field13" },
                        remark : "remark",
                    };
                }
            },
        },
        components:{
            // pagination,
        },
        data(){
            return{
                params:{
                    keyword: "",
                    belong: "",
                    project: "",
                    per_page: 20
                },
                last_page: 10,
                current_page: 1,
                total: 1000,
                list : [],

                // dialog START
                dialogVisible : false,
                form_params:{
                    params : ""
                },
                // DIALOG END
            }
        },
        methods:{
            getPage(obj){
                this.current_page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
    }
</script>
